// extracted by mini-css-extract-plugin
export default {"container":"styles_container__l3Ftf","header":"styles_header__ERnEW","travelAssignment":"styles_travelAssignment__GbEFu","card":"styles_card__-JcSH"};